"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _v = _interopRequireDefault(require("uuid/v4"));

var PARTY_TYPES = _interopRequireWildcard(require("./types"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function initialState(type) {
  var base = {
    "class": 'party',
    type: type,
    // 'debtor', 'codebtor', 'dependent', 'creditor', 'business', 'government', 'court'
    name: {
      display: null
    },
    phone: null,
    email: null,
    address: {}
  };

  if (type === PARTY_TYPES.DEBTOR) {
    base = _objectSpread(_objectSpread({}, base), {}, {
      name: {
        first: null,
        middle: null,
        last: null,
        suffix: null
      },
      altNames: [],
      signature: null,
      pastAddresses: [],
      // [address]
      ssns: [],
      // [{ full: null, inUse: null }]
      // ssn: null, // In use SSN
      itins: [],
      // itin: null, // In use ITIN
      businessNames: [],
      eins: [],
      district: {
        '180Days': true,
        reason: null
      },
      // Course Certificate (#1?)
      creditBriefing: {
        exempt: false,
        status: null
      },
      // Pay Stub Doc
      payRecord: {
        included: false,
        reason: null,
        additionalDescription: null
      },
      // Tax Returns
      taxRecord: {
        included: false
      } // income: {}, // NOTE: Summary

    });
  } else if (type === PARTY_TYPES.DEPENDENT) {
    base = _objectSpread(_objectSpread({}, base), {}, {
      age: null,
      relationship: null,
      livesWithDebtor: null
    });
  } else if (type === PARTY_TYPES.BUSINESS) {
    base = _objectSpread(_objectSpread({}, base), {}, {
      domain: null,
      ein: null,
      startedAt: null,
      endedAt: null
    });
  } else if (type === PARTY_TYPES.GOVERNMENT) {
    base = _objectSpread(_objectSpread({}, base), {}, {
      politicalLevel: null // NOTE: 'federal', 'state', 'local'

    });
  }

  return base;
}

var createParty = function createParty() {
  var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread(_objectSpread(_objectSpread({}, initialState(attrs.type)), attrs), {}, {
    id: (0, _v["default"])()
  });
};

var _default = createParty;
exports["default"] = _default;